// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
// import { Table } from 'react-bootstrap'
import { restrictSpecialChar, sortPortalPermissionByKey, isPermissionExist, restrictInValidCharLicense, isVehicleLimitExceeded } from '../../utils/helper'
import { Col, Row } from 'react-bootstrap'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { getVehicleModelList, getVehicleDetailsList } from '../../redux/actions/VehicleListAction'
import TextInput from '../../Global/Form/TextInput'

import Multiselect from 'multiselect-react-dropdown'

function VehicleModal(props) {

    const { permitListData, isModalOpen, setModal, modalName, partnerDetails, vehicleData, setVehicleData, handleSubmitVehicleData, submitButtonDisable, formError, setFormError, getVehicleList, dispatch, notify, vehicleTypeError, setVehicleTypeError } = props

    const [error, setError] = useState(false)
    const [vehicleMakeList, setVehicleMakeList] = useState(EMPTY_ARRAY)
    const [vehicleModelList, setvehicleModelList] = useState(EMPTY_ARRAY)
    const [vehicleInputDataLists, setVehicleInputDataLists] = useState(EMPTY_ARRAY)

    const [accessPermissions, setAccessPermissions] = useState('')
    // to handle the vehicle for menlo
    const allHaveMst_model = localStorage.getItem('allHaveMst_model') ? JSON.parse(localStorage.getItem('allHaveMst_model')) : true


    const handleModalFieldsData = (e, i) => {
        const { name, value, checked } = e.target
        if (name == 'make') {
            let modelData = vehicleInputDataLists?.make?.filter((v) => v.name == value)
            let modelList = modelData[0]?.mst_model
            let check = modelList?.some((value) => value?.name == 'Others')
            if (!check) {
                modelList?.unshift({
                    'id': 'Others',
                    'make_id': 'Others',
                    'name': 'Others'
                })
            }
            const newState = [...vehicleModelList]
            if (i < vehicleModelList.length) {
                newState[i] = modelData[0]?.mst_model
            } else {
                newState.push(modelData[0]?.mst_model)
            }
            let makeId = vehicleMakeList.filter((item) => {
                return item.name === value
            })
            setvehicleModelList(newState)
            vehicleData[i][name] = value
            vehicleData[i]['make_id'] = (value == 'Others') ? '' : makeId.length > 0 ? makeId[0].id : 0
            vehicleData[i]['maketext'] = value == 'Others' ? '' : value
            vehicleData[i]['othermake'] = (value == 'Others') ? true : false
            vehicleData[i]['othermodel'] = (value == 'Others') ? true : false
            vehicleData[i]['model_id'] = ''
            vehicleData[i]['modeltext'] = ''
            vehicleData[i]['model'] = ''
            vehicleData[i]['vehicleList'] = modelList
            setVehicleData([...vehicleData])
            setFormError(false)
        } else if (name == 'model') {

            let getModelId = vehicleModelList?.[i]?.filter(v => v?.name?.toLowerCase() === value?.toLowerCase())
            vehicleData[i]['model_id'] = (value == 'Others') ? '' : getModelId?.length > 0 ? getModelId?.[0]?.id : ''
            vehicleData[i]['modeltext'] = value == 'Others' ? '' : value
            vehicleData[i]['othermodel'] = (value == 'Others') ? true : false
            vehicleData[i][name] = value
            setVehicleData([...vehicleData])

        } else if (name == 'vehicle_type') {
            let getvehicletypeId = vehicleInputDataLists?.vehicletype?.filter((v) => v?.name === value)
            vehicleData[i]['vehicle_type_id'] = getvehicletypeId?.length > 0 ? getvehicletypeId?.[0]?.id : ''
            vehicleData[i][name] = value
            setVehicleData([...vehicleData])
            setVehicleTypeError(false)
        } else if (name == 'color') {
            let getColorId = vehicleInputDataLists?.color?.filter((v) => v?.name === value)
            vehicleData[i]['color_id'] = getColorId?.length > 0 ? getColorId?.[0]?.id : ''
            vehicleData[i][name] = value
            setVehicleData([...vehicleData])

        } else if (name == 'style') {
            let getStyleId = vehicleInputDataLists?.style?.filter((v) => v?.name === value)
            vehicleData[i]['style_id'] = getStyleId?.length > 0 ? getStyleId?.[0]?.id : ''
            vehicleData[i][name] = value
            setVehicleData([...vehicleData])
        } else if (name == 'country') {
            name == 'country' ? getStateByCountry(value) : ''
            vehicleData[i][name] = value
            setVehicleData([...vehicleData])
        } else if (name == 'license_plate') {
            vehicleData[i][name] = restrictInValidCharLicense(value)?.replace(/[^a-zA-Z0-9]/g, '')
            setVehicleData([...vehicleData])
            setFormError(false)
        } else if (name == 'is_default') {
            if (checked) {
                vehicleData.map((item) => {
                    delete item[name]
                    return item
                })
                vehicleData[i][name] = checked ? '1' : '0'
                setVehicleData([...vehicleData])
                setFormError(false)
            } else {
                delete vehicleData[i][name]
                setVehicleData([...vehicleData])
                setFormError(false)
            }
        } else {
            vehicleData[i][name] = value?.replace(/[^a-zA-Z0-9]/g, '')
            setVehicleData([...vehicleData])
            setFormError(false)
        }
    }



    const getStateByCountry = (value) => {
        let countryData = vehicleInputDataLists?.country?.filter((v) => v.country_code == value)
        dispatch(getVehicleModelList(partnerDetails?.facilities?.[0]?.country_code, countryData?.[0]?.id)).then((res) => {
            setVehicleInputDataLists(res)
            // setFormData({ ...formData, 'country': value })
        })

    }

    useEffect(() => {
        getVehical()
    }, EMPTY_ARRAY)

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])


    const getVehical = () => {
        dispatch(getVehicleDetailsList()).then((res) => {
            let makeList = res?.make
            if (allHaveMst_model) {
                makeList.unshift({ 'id': 'Others', 'name': 'Others', 'mst_model': [{ 'id': 'Others', 'make_id': 'Others', 'name': 'Others' }] })
            }
            setVehicleMakeList(makeList)
            setVehicleInputDataLists(res)
            // to add a key related to show the modal
            const vehicleModify = vehicleData?.map(item => ({ ...item, is_modal_show: allHaveMst_model }))
            setVehicleData(vehicleModify)
        })

    }

    useEffect(() => {
        getVehical()
    }, EMPTY_ARRAY)

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])




    // const addVehicleMake = () => {
    //     const payloadData = [...vehicleData]
    //     payloadData?.push({ 'license_plate': '', 'make_model': '' })
    //     setVehicleData([...payloadData])
    // }

    // const addVehicleSubmit = () => {
    //     const payloadData = [...vehicleData]
    //     // checking the every object item is empty or not 
    //     const testToSeeAllErrorsAreEmpty = payloadData?.every((item) => item?.license_plate !== '')
    //     //console.log('testToSeeAllErrorsAreEmpty?? payloadData',payloadData)
    //     let license_plate_valid = payloadData?.filter((item) => (item?.license_plate.length >= 3) ? item : null)
    //     //console.log('testToSeeAllErrorsAreEmpty?? filter',license_plate_valid, testToSeeAllErrorsAreEmpty)
    //     // console.log('testToSeeAllErrorsAreEmpty??',payloadData,payloadData?.filter((item) => (item?.license_plate.length>= 3)), testToSeeAllErrorsAreEmpty)

    //     if (license_plate_valid?.length > 0 && testToSeeAllErrorsAreEmpty === true) {

    //         handleSubmitVehicleData()
    //         setError('')
    //     } else if (testToSeeAllErrorsAreEmpty === false) {
    //         setError('Please Fill license plate!')
    //     } else if (license_plate_valid?.length < 1) {
    //         setError('Please Fill license plate at least 3 digit!')
    //     }
    // }

    const addVehicleMake = () => {
        const payloadData = [...vehicleData]
        // Check if all current vehicle inputs are filled
        let testToSeeAllErrorsAreEmpty = payloadData?.every(
            (item) => item?.license_plate !== '' 
        )


        let checkpermitLinkemplty=true
        if(isPermissionExist(accessPermissions, 'Permit Link with Vehicle')  && permitListData?.length > 0){
            checkpermitLinkemplty = payloadData?.every(
            (val) => val?.permit_ids?.length > 0
        )
        }
    


        const currentTotalVehicles = getVehicleList?.length + vehicleData?.length

        if (isVehicleLimitExceeded(accessPermissions, currentTotalVehicles, partnerDetails?.max_vehicle)) {
            notify('error', `You cannot add more than ${partnerDetails?.max_vehicle} vehicles.`)
            return
        }

        if (testToSeeAllErrorsAreEmpty && checkpermitLinkemplty) {
            payloadData.push({
                license_plate: '',
                make: '',
                model: '',
                color: '',
                state_id: '',
                othermake: false,
                othermodel: false,
                vehicleList: [],
                permit_ids:[],
                is_modal_show: allHaveMst_model,
            })
            setVehicleData([...payloadData])
            setError('')
        } else {
            setError('Please fill all inputs before adding another vehicle!')
        }
    }


    const removeVehicleMake = (e, i) => {
        const payloadData = [...vehicleData]
        payloadData?.splice(i, 1)
        setVehicleData([...payloadData])
    }

    useEffect(() => {
        if (formError) {
            setError('this field is required.')
        } else {
            setError('')
        }
    }, [formError])

    const onSelect = (selectedList, selectedItem, index) => {
        vehicleData[index]['permit_ids'] = selectedList
        setVehicleData([...vehicleData])
    }

    const onRemove = (selectedList, removedItem, index) => {
        vehicleData[index]['permit_ids'] = selectedList
        setVehicleData([...vehicleData])

    }



    return (
        <>
            {/* <Button onClick={() => setSmShow(true)} className="me-2">
                Small modal
            </Button> */}
            {/* <Button onClick={() => setLgShow(true)}>Large modal</Button> */}
            <Modal
                size="xl"
                show={isModalOpen}
                onHide={() => setModal(false)}
                aria-labelledby="example-modal-sizes-title-sm"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-sm">
                        {modalName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {vehicleData?.map((vehicleListItem, vehicleListIndex) => {
                        return (
                            <div className='bg-light border p-2 mb-2 position-relative' key={vehicleListIndex}>
                                <Row className='row g-2 row-cols-2  row-cols-sm-3 row-cols-md-4' >
                                    <Col className='mt-1'>
                                        <label className='form-label' >License Plate <span className="text-danger">*</span></label>
                                        <TextInput
                                            type="text"
                                            name='license_plate'
                                            required={true}
                                            className="form-control"
                                            placeholder="License Plate"
                                            maxLength={10}
                                            minLength={2}
                                            // onKeyDown={restrictSpecialChar}
                                            value={vehicleListItem?.license_plate || ''}
                                            onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}
                                            aria-describedby="emailHelp"
                                            spaceNotAllowed={true}
                                        />
                                        <small className='text-danger'>{(error && vehicleListItem?.license_plate == '') ? 'This field is required' : (error && vehicleListItem?.license_plate?.length < 2) ? 'Minimum 2 characters allowed' : ''}</small>

                                    </Col>


                                    {isPermissionExist(accessPermissions, 'Get Vehicle Make/Modal') ? <Col className='mt-1'>
                                        <label className="form-label">Vehicle Make {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <span className="text-danger">*</span> : ''}</label>
                                        {/* <label className='form-label' >Vehicle Make </label> */}
                                        <select autoComplete="off" name="make" placeholder="Make" onKeyDown={restrictSpecialChar} className="form-select form-control" value={vehicleListItem?.make || ''} id="make" onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}>
                                            <option value="">Select an option</option>
                                            {(vehicleMakeList?.length > 0) && vehicleMakeList?.map((val, index) => {
                                                return (
                                                    <option value={val?.name} key={index} >{val?.name}</option>
                                                )
                                            })}
                                        </select>
                                        {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <small className='text-danger'>{(error && vehicleListItem?.make == '') ? 'This field is required' : ''} </small> : ''}
                                        {/* <input
                                        type="text"
                                        name='make'
                                        className="form-control"
                                        placeholder="Make"
                                        onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}
                                        maxLength={15}
                                        minLength={4}
                                        onKeyDown={restrictSpecialChar}
                                        value={vehicleListItem?.make}
                                        aria-describedby="emailHelp" /> */}
                                    </Col> : null}
                                    {vehicleListItem?.othermake ? <Col className='mt-1'>
                                        <label className='form-label' >Make {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <span className="text-danger">*</span> : ''} </label>
                                        <input
                                            type="text"
                                            name='maketext'
                                            className="form-control"
                                            placeholder="Make"
                                            onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}
                                            maxLength={25}
                                            minLength={4}
                                            onKeyDown={restrictSpecialChar}
                                            value={vehicleListItem?.maketext || ''}
                                            aria-describedby="emailHelp" />
                                        {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <small className='text-danger'>{(error && vehicleListItem?.maketext == '') ? 'This field is required' : ''} </small> : ''}

                                    </Col> : ''}
                                    {isPermissionExist(accessPermissions, 'Get Vehicle Make/Modal') && !vehicleListItem?.othermake && vehicleListItem.is_modal_show ? <Col className='mt-1'>
                                        <label className='form-label' >Vehicle Model {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <span className="text-danger">*</span> : ''}</label>
                                        <select className='form-select form-control' value={vehicleListItem?.model || ''} placeholder="Model" name="model" id='state' onKeyDown={restrictSpecialChar} onChange={(e) => handleModalFieldsData(e, vehicleListIndex)} disabled={vehicleListItem?.make ? false : true}>
                                            <option value="0">Select an option</option>
                                            {(vehicleModelList?.length > 0) && vehicleModelList[vehicleListIndex]?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
                                        </select>
                                        {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <small className='text-danger'>{(error && vehicleListItem?.model == '') ? 'This field is required' : ''} </small> : ''}
                                        {/* <input
                                        type="text"
                                        name='modeltext'
                                        className="form-control"
                                        placeholder="Model"
                                        onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}
                                        maxLength={15}
                                        minLength={4}
                                        onKeyDown={restrictSpecialChar}
                                        value={vehicleListItem?.modeltext}
                                        aria-describedby="emailHelp" /> */}
                                    </Col> : ''}
                                    {((vehicleListItem?.othermake || vehicleListItem?.othermodel) && vehicleListItem.is_modal_show) ?
                                        <Col className='mt-1'>
                                            <label className='form-label' >Model {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <span className="text-danger">*</span> : ''}</label>

                                            {/* <select className='form-select form-control' value={vehicleListItem?.model} placeholder="Model" name="model" id='state' onKeyDown={restrictSpecialChar} onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}>
                                        <option value="0">Select an option</option>
                                        {(vehicleModelList?.length > 0) && vehicleModelList?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
                                    </select> */}
                                            <input
                                                type="text"
                                                name='modeltext'
                                                className="form-control"
                                                placeholder="Model"
                                                onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}
                                                maxLength={25}
                                                minLength={4}
                                                onKeyDown={restrictSpecialChar}
                                                value={vehicleListItem?.modeltext || ''}
                                                aria-describedby="emailHelp" />
                                            {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <small className='text-danger'>{(error && vehicleListItem?.modeltext == '') ? 'This field is required' : ''} </small> : ''}

                                        </Col> : ''}
                                    {/* vehicle type */}
                                    {isPermissionExist(accessPermissions, 'Get Vehicle Type') ?
                                        <div className='flex-1'>
                                            <label className='form-label' >Vehicle Type <span className="text-danger">*</span></label>
                                            <select name='vehicle_type' autoComplete="off" className='form-select form-control' value={vehicleListItem?.vehicle_type || ''} placeholder="vehicle_type" id='vehicle_type' onChange={(e) => handleModalFieldsData(e, vehicleListIndex)} onKeyDown={restrictSpecialChar}>
                                                <option value="">Select an option</option>
                                                {(vehicleInputDataLists?.vehicletype?.length > 0) && vehicleInputDataLists?.vehicletype?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
                                            </select>
                                            <small className='text-danger'>{((vehicleTypeError) && !vehicleListItem?.vehicle_type_id) ? 'This field is required' : ''}</small>
                                        </div>
                                        : ''}
                                    {/* vehicle type end */}
                                    {isPermissionExist(accessPermissions, 'Get Vehicle Color') ? <Col className='mt-1'>
                                        <label className='form-label' >Color {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <span className="text-danger">*</span> : ''} </label>
                                        <select name='color' autoComplete="off" className='form-select form-control' value={vehicleListItem?.color || ''} placeholder="Color" id='color' onChange={(e) => handleModalFieldsData(e, vehicleListIndex)} onKeyDown={restrictSpecialChar}>
                                            <option value="0">Select an option</option>
                                            {(vehicleInputDataLists?.color?.length > 0) && vehicleInputDataLists?.color?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
                                        </select>
                                        {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <small className='text-danger'>{(error && vehicleListItem?.color == '') ? 'This field is required' : ''} </small> : ''}

                                        {/* <input
                                        type="text"
                                        name='color'
                                        className="form-control"
                                        placeholder="Color"
                                        onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}
                                        maxLength={15}
                                        minLength={4}
                                        onKeyDown={restrictSpecialChar}
                                        value={vehicleListItem?.color}
                                        aria-describedby="emailHelp" /> */}
                                    </Col> : null}
                                    {isPermissionExist(accessPermissions, 'Get Vehicle Style') ? <Col className='mt-1'>
                                        <label className='form-label' >Style </label>
                                        <select name='style' autoComplete="off" className='form-select form-control' value={vehicleListItem?.style || ''} placeholder="Color" id='style' onChange={(e) => handleModalFieldsData(e, vehicleListIndex)} onKeyDown={restrictSpecialChar}>
                                            <option value="0">Select an option</option>
                                            {(vehicleInputDataLists?.style?.length > 0) && vehicleInputDataLists?.style?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.name}>{item?.name}</option>)}
                                        </select>


                                    </Col> : ''}
                                    {isPermissionExist(accessPermissions, 'Get Vehicle State') && isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ?
                                        <div className={'mt-1'}>
                                            <label className='form-label' >Country {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <span className="text-danger">*</span> : ''}</label>
                                            <select className='form-select form-control' value={vehicleListItem?.country || ''} placeholder="Country" name="country" id='country' onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}>
                                                <option value="">Select an option</option>
                                                {(vehicleInputDataLists?.country?.length > 0) && vehicleInputDataLists?.country?.map((item, itemIndex) => {
                                                    if (item?.country_code == 'US' || item?.country_code == 'CA' || item?.country_code == 'GB') {
                                                        return <option key={(itemIndex + 1)} value={item?.country_code} >{item?.name}</option>
                                                    }
                                                }
                                                )}
                                            </select>
                                            {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <small className='text-danger'>{(error && vehicleListItem?.country == '') ? 'This field is required' : ''} </small> : ''}
                                        </div> : ''}
                                    {isPermissionExist(accessPermissions, 'Get Vehicle State') ? <Col className='mt-1'>
                                        <label className='form-label' >State/Province {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <span className="text-danger">*</span> : ''}</label>
                                        <select className='form-select form-control' disabled={(isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && !vehicleListItem?.country) ? true : false} value={vehicleListItem?.state_id || ''} placeholder="State" name="state_id" id='state_id' onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}>
                                            <option value="">Select an option</option>
                                            {(vehicleInputDataLists?.state?.length > 0) && vehicleInputDataLists?.state?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.id}>{item?.state_code}</option>)}
                                        </select>
                                        {!isPermissionExist(accessPermissions, 'Vehicle Non Mandatory') ? <small className='text-danger'>{(error && vehicleListItem?.state_id == '') ? 'This field is required' : ''} </small> : ''}

                                    </Col> : null}
                                    {isPermissionExist(accessPermissions, 'Vin Number') ? <Col className='mt-1'>
                                        <label className='form-label' >Vehicle Identification Number</label>
                                        <input
                                            type="text"
                                            name='vehicle_number'
                                            className="form-control"
                                            placeholder="Vehicle Identification Number"
                                            maxLength={20}
                                            onKeyDown={restrictSpecialChar}
                                            value={vehicleListItem?.vehicle_number || ''}
                                            onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}
                                            aria-describedby="emailHelp" />
                                        {/* <small className='text-danger'>{error}</small> */}

                                    </Col> : ''}

                                    {/* vehicle type */}
                                    {isPermissionExist(accessPermissions, 'Permit Link with Vehicle') && permitListData?.length > 0 ?
                                        <div className='flex-1'>
                                            <label className='form-label' >Permit Number <span className="text-danger">*</span></label>
                                            <Multiselect
                                                options={permitListData} // Options to display in the dropdown
                                                selectedValues={vehicleListItem?.permit_ids} // Preselected value to persist in dropdown
                                                onSelect={(list, item) => onSelect(list, item, vehicleListIndex)}
                                                onRemove={(list, item) => onRemove(list, item, vehicleListIndex)} // Function will trigger on select event  
                                                // onRemove={onRemove} // Function will trigger on remove event
                                                displayValue="account_number" // Property name to display in the dropdown options
                                                showCheckbox={true}
                                                emptyRecordMsg={'Permit not found.'}
                                                className='multi-select-service'
                                                hidePlaceholder={true}
                                            // disable={isServiceDisabled}
                                            />
                                            <small className='text-danger'>{(error && permitListData?.length > 0 && vehicleListItem?.permit_ids?.length <= 0) ? 'This field is required' : ''}</small>
                                       </div>
                                        : ''}
                                    {/* vehicle type end */}

                                </Row>

                                <Col className='mt-3'>
                                    <div className='switch-wrap'>
                                        <input className='w-auto' type={'checkbox'} id={'is_default_' + vehicleListIndex} name='is_default' checked={vehicleListItem?.is_default == '1'} onChange={(e) => handleModalFieldsData(e, vehicleListIndex)} />
                                        <label htmlFor={'is_default_' + vehicleListIndex} className='fw-normal ps-2' > Mark as default</label>
                                    </div>
                                </Col>

                                <Col xl="auto" className='top-0 right-0 position-absolute '>
                                    {vehicleData?.length - 1 === vehicleListIndex ?
                                        <button type="button" className="btn btn-primary btn-sm" onClick={addVehicleMake}><i className="fa fa-plus"></i> </button> :
                                        vehicleListIndex !== -1 ? <button type="button" className="btn btn-danger btn-sm w-100" onClick={(e) => removeVehicleMake(e, vehicleListIndex)}><i className="fa fa-minus"></i></button> :
                                            null
                                    }
                                </Col>
                            </div>

                        )
                    })}
                </Modal.Body>
                <Modal.Footer>
                    {/* <Button type="submit" data-bs-dismiss="modal" className="btn btn-primary" disabled={submitButtonDisable} onClick={handleSubmitVehicleData} >Submit</Button> */}
                    <div className='row d-block w-100'>

                        <div className='d-flex align-items-end justify-content-end'>
                            <Button type="submit" data-bs-dismiss="modal" disabled={submitButtonDisable} onClick={handleSubmitVehicleData} style={{ float: 'right', marginTop: '5px' }}>Submit</Button>
                        </div>
                        <div style={{ float: 'right' }} className='text-end'>
                            <small className='small'>License plate is required and should have 2 to 10 characters.</small>
                        </div>

                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

VehicleModal.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    modalName: PropTypes.string,
    vehicleData: PropTypes.EMPTY_ARRAY,
    setVehicleData: PropTypes.func,
    handleSubmitVehicleData: PropTypes.func,
    isModalOpen: PropTypes.bool,
    setModal: PropTypes.func,
    submitButtonDisable: PropTypes.bool,
    formError: PropTypes.bool,
    setFormError: PropTypes.func,
    getVehicleList: PropTypes.object,
    vehicleInputDataLists: PropTypes.array,
    notify: PropTypes.func,
    partnerDetails: PropTypes.object,
    vehicleTypeError: PropTypes.bool,
    setVehicleTypeError: PropTypes.func,
    permitListData: PropTypes.array,
}

VehicleModal.defaulProps = {
    dispatch: noop,
    loader: false,
    modalName: undefined,
    vehicleData: EMPTY_ARRAY,
    setVehicleData: noop,
    handleSubmitVehicleData: noop,
    isModalOpen: false,
    setModal: noop,
    submitButtonDisable: false,
    formError: false,
    setFormError: noop,
    getVehicleList: EMPTY_OBJECT,
    vehicleInputDataLists: EMPTY_ARRAY,
    notify: noop,
    partnerDetails: EMPTY_OBJECT,
    setVehicleTypeError: noop,
    vehicleTypeError: false,
    permitListData: EMPTY_ARRAY,
}

function mapStateToProps({ state }) {
    return { state }
}
export default connect(mapStateToProps)(VehicleModal)
